import { Component, Input, OnInit } from '@angular/core';
import { CompanyDirectorship } from '../../../core/models';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-director-card-img',
  templateUrl: './director-card-img.component.html',
  styleUrls: ['./director-card-img.component.scss'],
})
export class DirectorCardImgComponent implements OnInit {
  @Input() directorship: CompanyDirectorship;
  @Input() scale = 1;

  imageWidth = 195;
  imageHeight = 273;
  imageDirectorHeight = 155;
  imageDirectorMarginTop = 34;
  directorFirstNameTop = 187;
  directorLastNameTop = 205;
  directorCompanyTop = 235;
  directorImage = './assets/media/static/george_rainbow_mohawk_min.webp';

  ngOnInit(): void {
    if (this.directorship.director.picture) {
      this.directorImage = `${environment.directorPictures}${this.directorship.director.picture}`;
    }
  }
}
